import $ from 'jquery';
import {api} from '../utils/api.js';
import {notifier} from '../utils/notifier.js';

function getAvailableServiceEntries(services) {
	return Object.entries(services || {})
		.map(([service, tariffs]) => [
			service,
			Array.isArray(tariffs)
				? tariffs.filter(tariff => tariff && typeof tariff === 'object' && tariff.NAME)
				: [],
		])
		.filter(([, tariffs]) => tariffs.length > 0);
}

function appendUnavailableMessage($container, social, isActive) {
	$container.append(`
		<div class="tabs-contents__data service-unavailable ${isActive ? 'is-active' : ''}" data-option-inner-btn-target="${social}">
			<p class="service-unavailable__text">Для этой социальной сети сейчас нет доступных тарифов.</p>
		</div>
	`);
}

export function generateOrderForm(social, services, isActive = false) {
	const $contentContainer = $('.calc__block--second');
	const $tabContent = $(`<div class="tabs-contents__data ${isActive ? 'is-active' : ''}" data-option-inner-btn-target="${social}"></div>`);
	const serviceEntries = getAvailableServiceEntries(services);

	if (!serviceEntries.length) {
		appendUnavailableMessage($contentContainer, social, isActive);
		return;
	}

	serviceEntries.forEach(([service, tariffs], index) => {
		const tabId = `${social}-${service.toLowerCase()}`;
		const firstTariff = tariffs[0];
		// console.log(firstTariff)
		const $content = $(`<div class="tabs__content tabs-content ${index === 0 ? 'tabs__content--active' : ''}" data-tabs-target="${tabId}" role="tabpanel" tabindex="0">
			<div class="tabs-content__inner" data-tabs-content-inner="">
		  		<div class="tabs-content__block flex-column">
					<label class="calc__label flex">
			  			<span class="calc__label-txt">Выберите тариф <span class="calc__label-req">*</span></span>
					</label>
				<div class="select" data-select="">
				  	<button class="select__title btn-res flex-align-center state-color" data-select-title="">
						<span class="select__value">${firstTariff.NAME} (${firstTariff.FINAL_RATE} ₽/шт)</span>
					</button>
				  	<div class="select__content" data-select-content="">
						<ul class="select__options list-res" data-select-options=""></ul>
				  	</div>
				</div>
			  	</div>
			  	<div class="tabs-content__block flex-column">
					<label class="calc__label flex">
				  		<span class="calc__label-txt">Количество <span class="calc__label-req">*</span></span>
					</label>
					<input class="input quantity" min="${firstTariff.MIN_QUANTITY}" max="${firstTariff.MAX_QUANTITY}" value="${firstTariff.MIN_QUANTITY}" type="number" data-order-quantity>
			  	</div>
			  	<div class="tabs-content__block flex-column" data-service-description>${firstTariff.DESCRIPTION}</div>
			  	<div class="tabs-content__block flex-column">
				<label class="calc__label flex">
				  <span class="calc__label-txt"><span data-placeholder-text>Ссылка на профиль</span><span class="calc__label-req">*</span></span>
				</label>
				<input class="input input--icon input--icon-link url" type="text" data-order-url placeholder="${firstTariff.URL_PLACEHOLDER}">
			  	</div>
				<div class="tabs-content__block flex-column">
					<label class="calc__label flex">
						<span class="calc__label-txt">Промокод</span>
					</label>
					<input class="input promo" type="text">
				</div>
				<div class="tabs-content__block flex-column">
					<label class="calc__label flex">
						<span class="calc__label-txt">Комментарий</span>
					</label>
					<textarea class="textarea" data-order-comment></textarea>
				</div>
				<footer class="tabs-content__footer flex-column">
					<span class="tabs-content__result result">
						Итог: <span class="result__number">${firstTariff.FINAL_RATE * firstTariff.MIN_QUANTITY}</span> <span class="result__currency currency">₽</span>
					</span>
					<button data-create-order class="tabs-content__btn btn btn-res">Оформить заказ</button>
				</footer>
			</div>
  		</div>`);

		const $tariffList = $content.find('.select__options');
		tariffs.forEach((tariff, index) => {
			const $option = $(`<li class="select__option" data-select-option="">
	  			<button data-select-value="${tariff.SERVICE_ID}" class="select__button btn-res flex-align-center state-color ${index === 0 ? 'is-active' : ''}"
                  	data-option-inner-button="${social}"
                  	data-rate="${tariff.FINAL_RATE}"
                  	data-min="${tariff.MIN_QUANTITY}"
                  	data-max="${tariff.MAX_QUANTITY}">
            		<span class="select__value">${tariff.NAME} (${tariff.FINAL_RATE} ₽/шт)</span>
          		</button>
        	</li>`);
			$option.find('button').data('tariff', tariff);
			$tariffList.append($option);
		});

		$tabContent.append($content);
	});

	$contentContainer.append($tabContent);
}
export function generateOrderFormPersonal(social, services, isActive = false) {
	const $contentContainer = $('.calc__block--second');
	const $tabContent = $(`<div class="tabs-contents__data ${isActive ? 'is-active' : ''}" data-option-inner-btn-target="${social}"></div>`);
	const serviceEntries = getAvailableServiceEntries(services);

	if (!serviceEntries.length) {
		appendUnavailableMessage($contentContainer, social, isActive);
		return;
	}

	serviceEntries.forEach(([service, tariffs], index) => {
		const tabId = `${social}-${service.toLowerCase()}`;
		const firstTariff = tariffs[0];
		// console.log(firstTariff)
		const $content = $(`<div class="tabs__content tabs-content ${index === 0 ? 'tabs__content--active' : ''}" data-tabs-target="${tabId}" role="tabpanel" tabindex="0">
			<div class="tabs-content__inner" data-tabs-content-inner="">
		  		<div class="tabs-content__block flex-column">
					<label class="calc__label flex">
			  			<span class="calc__label-txt">Выберите тариф <span class="calc__label-req">*</span></span>
					</label>
				<div class="select" data-select="">
				  	<button class="select__title btn-res flex-align-center state-color" data-select-title="">
						<span class="select__value">${firstTariff.NAME} (${firstTariff.FINAL_RATE} ₽/шт)</span>
					</button>
				  	<div class="select__content" data-select-content="">
						<ul class="select__options list-res" data-select-options=""></ul>
				  	</div>
				</div>
			  	</div>
			  	<div class="tabs-content__block flex-column">
					<label class="calc__label flex">
				  		<span class="calc__label-txt">Количество <span class="calc__label-req">*</span></span>
					</label>
					<input class="input quantity" min="${firstTariff.MIN_QUANTITY}" max="${firstTariff.MAX_QUANTITY}" value="${firstTariff.MIN_QUANTITY}" type="number" data-order-quantity>
			  	</div>

			  	<div class="tabs-content__block flex-column">
				<label class="calc__label flex">
				  <span class="calc__label-txt"><span data-placeholder-text>Ссылка на профиль</span><span class="calc__label-req">*</span></span>
				</label>
				<input class="input input--icon input--icon-link url" type="text" data-order-url placeholder="${firstTariff.URL_PLACEHOLDER}">
			  	</div>
				<div class="tabs-content__block flex-column">
					<label class="calc__label flex">
						<span class="calc__label-txt">Промокод</span>
					</label>
					<input class="input promo" type="text">
				</div>
				<div class="tabs-content__block flex-column">
					<label class="calc__label flex">
						<span class="calc__label-txt">Комментарий</span>
					</label>
					<textarea class="textarea" data-order-comment></textarea>
				</div>
				<footer class="tabs-content__footer flex-column">
					<span class="tabs-content__result result">
						Итог: <span class="result__number">${firstTariff.FINAL_RATE * firstTariff.MIN_QUANTITY}</span> <span class="result__currency currency">₽</span>
					</span>
					<button data-create-order class="tabs-content__btn btn btn-res">Оформить заказ</button>
				</footer>
			</div>
			<div class="tabs-content__inner" data-tabs-content-inner>
				<div class="calc__tariff-info tariff-info flex-column is-active" data-option-inner-btn-target="instagram-subscribers-tariff-one" data-tariff-info>
					<div class="tariff-info__block">
						<h3 class="tariff-info__title flex">
							<img class="tariff-info__icon title-icon" src="/local/templates/neolikes/assets/images/icons/quest.svg" width="24" height="24" alt="Иконка вопроса" loading="lazy" decoding="auto" aria-hidden="true" >
							Описание тарифа
						</h3>

						<div class="tariff-info__descr" data-service-description>
							${firstTariff.DESCRIPTION}
						</div>
					</div>
				</div>
			</div>
  		</div>`);

		const $tariffList = $content.find('.select__options');
		tariffs.forEach((tariff, index) => {
			const $option = $(`<li class="select__option" data-select-option="">
	  			<button data-select-value="${tariff.SERVICE_ID}" class="select__button btn-res flex-align-center state-color ${index === 0 ? 'is-active' : ''}"
                  	data-option-inner-button="${social}"
                  	data-rate="${tariff.FINAL_RATE}"
                  	data-min="${tariff.MIN_QUANTITY}"
                  	data-max="${tariff.MAX_QUANTITY}">
            		<span class="select__value">${tariff.NAME} (${tariff.FINAL_RATE} ₽/шт)</span>
          		</button>
        	</li>`);
			$option.find('button').data('tariff', tariff);
			$tariffList.append($option);
		});

		$tabContent.append($content);
	});

	$contentContainer.append($tabContent);
}

export function updateTotal($container) {
	const $selectedTariff = $container.find('.select__button.is-active');
	if ($selectedTariff.length) {
		const tariff = $selectedTariff.data('tariff');
		const $description = $container.find('[data-service-description]');
		if (tariff?.DESCRIPTION) {
			$description.html(tariff.DESCRIPTION).show();
		} else {
			$description.hide();
		}

		$container.find('[data-placeholder-text]').text(tariff?.TEXT_PLACEHOLDER);
		$container.find('.quantity').attr({
			value: tariff?.MIN_QUANTITY,
			min: tariff?.MIN_QUANTITY,
			max: tariff?.MAX_QUANTITY,
		});
		$container.find('.url').attr('placeholder', tariff?.URL_PLACEHOLDER);

		const rate = parseFloat($selectedTariff.data('rate') || 0);
		const quantity = parseInt($container.find('.quantity').val() || 0);
		const total = rate * quantity;
		$container.find('[data-create-order]').data('price', total);
		$container.find('.result__number').text(total.toFixed(2));
	}
}

export function initOrderForm() {
	$(document).on('click', '[data-calc] .select__button', function () {
		const $this = $(this);
		const $select = $this.closest('.select');
		$select.find('.select__button').removeClass('is-active');
		$this.addClass('is-active');
		$select.find('.select__value').first().text($this.find('.select__value').text());
		$select.find('.select__content').removeClass('is-active');
		$select.find('.select__title').attr('aria-expanded', false);
		updateTotal($('.calc__block--second .tabs-contents__data.is-active'));
	});

	$(document).on('input', '[data-calc] .quantity', function () {
		const $content = $(this).closest('.tabs__content');
		const min = parseInt($(this).attr('min'));
		const max = parseInt($(this).attr('max'));
		let value = parseInt($(this).val());
		if (value < min) $(this).val(min);
		if (value > max) $(this).val(max);
		updateTotal($('.calc__block--second .tabs-contents__data.is-active'));
	});

	$(document).on('click', '[data-calc] [data-create-order]', async function (e) {
		e.preventDefault();
		const $this = $(this);
		const price = $this.data('price');
		const $parent = $this.closest('[data-tabs-content-inner]');
		const $selectedTariff = $parent.find('[data-select-value].is-active');
		const serviceId = $selectedTariff.data('select-value');
		const url = $parent.find('[data-order-url]').val() ?? '';
		const quantity = $parent.find('[data-order-quantity]').val() ?? 0;
		const comment = $parent.find('[data-order-comment]').val() ?? '';

		if (price < 1) {
			return notifier.alert('Сумма заказа не может быть меньше 1 рубля.');
		}

		if(!url){
			return notifier.alert('Введите ссылку на профиль');
		}

		if(!quantity){
			return notifier.alert('Введите количество');
		}

		try {

			if(application.isAuthorized){
				const response = await api.post('/api/createOrder', {
					serviceId,
					link: url,
					quantity,
					comment,
				});

				if (response.result && response.payment_url) {
					window.location.href = response.payment_url;
				}
			}else{
				notifier.confirm('Хотите создать заказ анонимно (без регистрации)?',
					async function(){
						const response = await api.post('/api/createOrder', {
							serviceId,
							link: url,
							quantity,
							comment,
						});

						if (response.result && response.payment_url) {
							window.location.href = response.payment_url;
						}
					},
					function(){
						MicroModal.show('modal-register')
					},
					{
						labels: {
							confirm: '',
							confirmOk: 'Да',
							confirmCancel: 'Нет',
						}
					}
				);
			}
		} catch (error) {
			console.error('Axios error:', error.response?.status, error.response?.data, error);
			notifier.alert('Ошибка сервера. Попробуйте позже.');
		}
	});

	updateTotal($('.calc__block--second .tabs-contents__data.is-active'));
}
